import type { ComponentProps } from 'react';

import { useQuery } from '@tanstack/react-query';

import { organizationsQuery } from '@apis/eloc/queries/organizations';
import { Skeleton } from '@packages/fenrir/components/skeleton';
import { Typography } from '@packages/fenrir/components/typography';

import { OrganizationsAutocomplete } from './organizations-autocomplete';

type OrganizationSwitchProps = Omit<
  ComponentProps<typeof OrganizationsAutocomplete>,
  'organizations'
>;

export const OrganizationSwitch = ({
  width,
  ...rest
}: OrganizationSwitchProps) => {
  const { data: organizations, isLoading } = useQuery(organizationsQuery());

  if (isLoading || !organizations)
    return <Skeleton variant="rectangular" width={width} />;

  if (organizations.length === 1)
    return <Typography>{organizations[0].name}</Typography>;

  return (
    <OrganizationsAutocomplete
      organizations={organizations}
      width={width}
      {...rest}
    />
  );
};
